import { Pipe, PipeTransform } from '@angular/core';


import { transformFileURI } from '@wm/core';

import { getImageUrl } from '../utils/widget-utils';

@Pipe({
    name: 'image',
    standalone: true
})
export class ImagePipe implements PipeTransform {
    transform(url: string, encode?: string, defaultImageUrl?: string) {
        return transformFileURI(getImageUrl(url, encode, defaultImageUrl));
    }
}
